// =============================================================================
// SIREPPAR - Contador de consultas que esperan respuesta de la SEP
// =============================================================================
// Lo usa el menú interno. Se refresca solo cada minuto y, además, cada vez que
// alguien responde, cierra o inicia una consulta desde esta sesión (las
// pantallas invalidan la clave 'sep-consultas-pendientes').
// =============================================================================

import { useQuery } from '@tanstack/react-query';
import { consultaSepService } from '../services/api';
import { CONSULTAS_HABILITADAS } from '../utils/consultas';

export const CLAVE_CONSULTAS_PENDIENTES = ['sep-consultas-pendientes'];

export function useConsultasPendientes(habilitado: boolean): number {
  const { data } = useQuery({
    queryKey: CLAVE_CONSULTAS_PENDIENTES,
    queryFn: () => consultaSepService.pendientes(),
    enabled: habilitado && CONSULTAS_HABILITADAS,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
  return data?.data?.cantidad ?? 0;
}
